// LoginSuccess.jsx
import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { UserContext } from "../../Context/UserContext.js";
import { jwtDecode } from "jwt-decode";
import Swal from "sweetalert2";
import { logOut } from "../../Utilities/logOut.js";
import { CartContext } from "../../Context/CartContext.js";



export default function LoginSuccessGoogle() {
   const navigate = useNavigate();
   const location = useLocation(); 
   const {setUserToken , setLoggedUser , setCompleteInfoUser , setAdmin , setModerator , setUser} = useContext(UserContext) ;
   const user = useContext(UserContext) ;
   const {getLoggedCart } = useContext(CartContext) ;


   useEffect(() => {
      const urlParams = new URLSearchParams(location.search);  // استخراج الـ query params
      const token = urlParams.get("token");
      const token_expiration = Number(process.env.REACT_APP_TOKEN_EXPIRATION) || 7210000 ;

      if (token) {
         localStorage.setItem("token", token);
         setUserToken(token);

         const decoded = jwtDecode(token);
         setLoggedUser(decoded);

         //& Get Item In Logged User Cart : 
         getLoggedCart() ; 

         if(decoded.phone === undefined || decoded.birthDay === undefined){
            setCompleteInfoUser(false)
            setTimeout(() => {
               Swal.fire({
                  title: 'يرجى تكملة البيانات',
                  text: 'بياناتك غير مكتملة، من فضلك قم بتحديثها.',
                  icon: 'warning',
                  confirmButtonText: 'تعديل البيانات',
                  showCancelButton: true,
                  cancelButtonText: 'لاحقاً'
               }).then((result) => {
                  if (result.isConfirmed) {
                     navigate('/CompleteProfile') ; // غيّر ده حسب مسار صفحة التعديل عندك
                  }
               });
            }, 3000);
         }


            setTimeout(() => {
               handleLogOut()
            } , (token_expiration)) ;    
            // After 1 hours   logout
            // 60*10*1000 = 600,000= 10 minute
            // 60*20*2*1000 = 2400,000= 1/3 hours
            // 60*60*1000 = 3600,000= 1 hours  
            // 60*60*2*1000 = 7200,000= 2 hours 


         if(decoded.role === "user"){
            navigate("/home") ;
         }else if(decoded.role === "admin" || decoded.role  === "moderator"){
            navigate("/dashboard") ;
         }
      } ;
   }, []);

   //& Handle Log Out :
   function handleLogOut(){
      logOut(navigate , user)

      Swal.fire({
         title:"Session Expired !" ,
         text: "Session Expired .Please Try Log in Again !!" ,   
         icon: "error"
      });
   }

   return (
      <div className="d-flex justify-content-center align-items-center">
         <h1>جارٍ تسجيل الدخول...</h1>
      </div> 
   )
} ;

